import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class ModalComponent {
  //Class Value; bootstap button class
  @Input() buttonClass: string;

  @Input() label: string;

  @Input() visible: string;

  @Input() title: string;

  @Input() text: string;

  //Position Value; modal-dialog-centered
  @Input() position: string;

  //Width Value; modal-lg, modal-sm
  @Input() size: string;

  @Input() closeButton: boolean = true;

  @Input() footer: boolean = true;

  @Input() cancelButton: boolean = true;

  @Input() cancelButtonLabel: string = 'İptal';

  //Class Value; bootstap button class
  @Input() cancelButtonStyle: string = 'btn btn-danger light';

  @Input() saveButton: boolean = true;

  @Input() saveButtonLabel: string = 'Kaydet';

  //Class Value; bootstap button class
  @Input() saveButtonStyle: string = 'btn btn-primary';

  @Output() saveButtonClickEvent = new EventEmitter<any>();

  onClickSaveButton(event: any) {
    this.saveButtonClickEvent.emit(event);
  }
}
